:host{display:flex;flex-direction:row;flex:1}.content,.options{font-size:3.8rem;flex:1}.options{display:flex;flex-direction:column;flex:0;margin:0 .6rem 0 0}
/*# sourceMappingURL=assignment-gap-match-text.component-AUASWQON.css.map */
